module.exports = __webpack_public_path__ + "static/media/0028_LES_ENSEIGNES_LA_BOULANGERIE_DES_SAVEURS.964a59e0.webp";